import { CorpId, CorpType, ExtValues, IMember, IRole, MemberStatus } from '@libs/shared';

/** 成员profile */
export interface IMemberProfile extends Pick<IMember, 'nickname' | 'is_owner' | 'avatar' | 'type'> {
    corp_id?: CorpId; // 成员所在企业id
    corp_type: CorpType;
    corp_name: string;
    can_update_nickname: boolean;
    ext?: ExtValues; // 预设字段
}

/**
 * 离职成员
 */
export interface IResignedMember extends Omit<IMember, 'role' | 'dept'> {
    role: IRole[];
    status: MemberStatus.dismission;
    ext?: ExtValues; // 预设字段
}

/**
 * 恢复离职成员所需的最小成员信息
 */
export type ResignedMemberRecoveryInfo = Pick<IResignedMember, 'nickname' | 'username' | 'ext'>;

/**
 * 外部对接人
 */
export type IGuestMember = Omit<IMember, 'label'>;

/**
 * 成员filter的类型
 */
export enum MemberFilterStatus {
    ALL = 'all', // 全部
    INVITING = 'inviting', // 邀请中
    FROZEN = 'frozen', // 停用成员
    ENABLED = 'enabled' // 启用成员
}
